export const GET_VERIFICATION_DOCUMENT_LIST="GET_VERIFICATION_DOCUMENT_LIST"
export const GET_VERIFICATION_DOCUMENT_LIST_SUCCESS="GET_VERIFICATION_DOCUMENT_LIST_SUCCESS"
export const GET_VERIFICATION_DOCUMENT_LIST_FAILED="GET_VERIFICATION_DOCUMENT_LIST_FAILED"

export const GET_VERIFICATION_DOCUMENT_VIEW_DETAILS="GET_VERIFICATION_DOCUMENT_VIEW_DETAILS"
export const GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_SUCCESS="GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_SUCCESS"
export const GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_FAILED="GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_FAILED"